import {
    API_FACE_COMPARISON
} from "../constants/apiEndPoints";

import {axiosBodyToAPI} from '../commons/shared';

export const fetchPostFaceComparisonApi = (params = {}) => {
    const {formData, requestId} = params;
    return axiosBodyToAPI('POST', API_FACE_COMPARISON, formData, requestId);
};